import React from "react";
import { Helmet } from "react-helmet";

const Meta = ({ title, description, cannonicalTag, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={cannonicalTag} />
      <meta name="keyword" content={keywords} />
    </Helmet>
  );
};

// Meta.defaultProps = {
//   title:
//     "EMotorad | Buy Electric Bicycle & Bike Online | Best E Bicycle & E Bike",
//   description:
//     "EMotorad offers high tech, reliable, and fast electric cycles with premium quality. Now book e bicycle & e bike online with EMotorad at best price.",
//   keywords: "",
// };

export default Meta;
